import { supabase, isSupabaseConfigured } from '@/lib/supabase';
import { resolveCurrentPermissions } from '@/services/permissions';

// Ficha de vendedor vinculada al usuario autenticado.
export interface CurrentSalesperson {
  id: string;
  fullName: string;
}

// Resuelve la ficha de vendedor del usuario logueado buscando por email.
// Permite que un "agente de ventas" vea solo lo que él facturó sin necesitar
// una columna user_id extra: el email de `app_users` coincide con el del
// vendedor (se vincularon al invitar al agente al panel).
export async function resolveCurrentSalesperson(): Promise<CurrentSalesperson | null> {
  if (!isSupabaseConfigured || !supabase) return null;
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    const email = sessionData.session?.user?.email;
    if (!email) return null;

    const { data } = await supabase
      .from('salespersons')
      .select('id, full_name')
      .eq('email', email)
      .maybeSingle();

    if (!data) return null;
    const row = data as { id: string; full_name: string };
    return { id: row.id, fullName: row.full_name };
  } catch {
    return null;
  }
}

// Devuelve el id del vendedor SI el usuario autenticado es un agente de
// ventas; en cualquier otro caso (admin u otro rol) devuelve null.
// Es la llave que permite filtrar ventas/comisiones a "solo lo suyo".
export async function getAgentSalespersonId(): Promise<string | null> {
  const profile = await resolveCurrentPermissions();
  if (!profile || profile.role !== 'sales_agent') return null;
  const sp = await resolveCurrentSalesperson();
  return sp?.id ?? null;
}